/**
 * ApiGest API
 * ApiGest API documentation
 *
 * OpenAPI spec version: 1.0.0
 * Contact: info@eneasys.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { UserDTO } from '../model/userDTO';

import { AIG_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UserResourceService {

    protected basePath = 'https://api-gest.eneasys.net';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(AIG_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * countUsers
     * 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param statusEquals 
     * @param statusIn 
     * @param statusNotEquals 
     * @param statusSpecified 
     * @param typeEquals 
     * @param typeIn 
     * @param typeNotEquals 
     * @param typeSpecified 
     * @param userCodeContains 
     * @param userCodeDoesNotContain 
     * @param userCodeEquals 
     * @param userCodeIn 
     * @param userCodeNotEquals 
     * @param userCodeSpecified 
     * @param userMemberOfIdEquals 
     * @param userMemberOfIdGreaterThan 
     * @param userMemberOfIdGreaterThanOrEqual 
     * @param userMemberOfIdIn 
     * @param userMemberOfIdLessThan 
     * @param userMemberOfIdLessThanOrEqual 
     * @param userMemberOfIdNotEquals 
     * @param userMemberOfIdSpecified 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public countUsersUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, statusEquals?: string, statusIn?: Array<string>, statusNotEquals?: string, statusSpecified?: boolean, typeEquals?: string, typeIn?: Array<string>, typeNotEquals?: string, typeSpecified?: boolean, userCodeContains?: string, userCodeDoesNotContain?: string, userCodeEquals?: string, userCodeIn?: Array<string>, userCodeNotEquals?: string, userCodeSpecified?: boolean, userMemberOfIdEquals?: number, userMemberOfIdGreaterThan?: number, userMemberOfIdGreaterThanOrEqual?: number, userMemberOfIdIn?: Array<number>, userMemberOfIdLessThan?: number, userMemberOfIdLessThanOrEqual?: number, userMemberOfIdNotEquals?: number, userMemberOfIdSpecified?: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public countUsersUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, statusEquals?: string, statusIn?: Array<string>, statusNotEquals?: string, statusSpecified?: boolean, typeEquals?: string, typeIn?: Array<string>, typeNotEquals?: string, typeSpecified?: boolean, userCodeContains?: string, userCodeDoesNotContain?: string, userCodeEquals?: string, userCodeIn?: Array<string>, userCodeNotEquals?: string, userCodeSpecified?: boolean, userMemberOfIdEquals?: number, userMemberOfIdGreaterThan?: number, userMemberOfIdGreaterThanOrEqual?: number, userMemberOfIdIn?: Array<number>, userMemberOfIdLessThan?: number, userMemberOfIdLessThanOrEqual?: number, userMemberOfIdNotEquals?: number, userMemberOfIdSpecified?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public countUsersUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, statusEquals?: string, statusIn?: Array<string>, statusNotEquals?: string, statusSpecified?: boolean, typeEquals?: string, typeIn?: Array<string>, typeNotEquals?: string, typeSpecified?: boolean, userCodeContains?: string, userCodeDoesNotContain?: string, userCodeEquals?: string, userCodeIn?: Array<string>, userCodeNotEquals?: string, userCodeSpecified?: boolean, userMemberOfIdEquals?: number, userMemberOfIdGreaterThan?: number, userMemberOfIdGreaterThanOrEqual?: number, userMemberOfIdIn?: Array<number>, userMemberOfIdLessThan?: number, userMemberOfIdLessThanOrEqual?: number, userMemberOfIdNotEquals?: number, userMemberOfIdSpecified?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public countUsersUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, statusEquals?: string, statusIn?: Array<string>, statusNotEquals?: string, statusSpecified?: boolean, typeEquals?: string, typeIn?: Array<string>, typeNotEquals?: string, typeSpecified?: boolean, userCodeContains?: string, userCodeDoesNotContain?: string, userCodeEquals?: string, userCodeIn?: Array<string>, userCodeNotEquals?: string, userCodeSpecified?: boolean, userMemberOfIdEquals?: number, userMemberOfIdGreaterThan?: number, userMemberOfIdGreaterThanOrEqual?: number, userMemberOfIdIn?: Array<number>, userMemberOfIdLessThan?: number, userMemberOfIdLessThanOrEqual?: number, userMemberOfIdNotEquals?: number, userMemberOfIdSpecified?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (statusEquals !== undefined && statusEquals !== null) {
            queryParameters = queryParameters.set('status.equals', <any>statusEquals);
        }
        if (statusIn) {
            statusIn.forEach((element) => {
                queryParameters = queryParameters.append('status.in', <any>element);
            })
        }
        if (statusNotEquals !== undefined && statusNotEquals !== null) {
            queryParameters = queryParameters.set('status.notEquals', <any>statusNotEquals);
        }
        if (statusSpecified !== undefined && statusSpecified !== null) {
            queryParameters = queryParameters.set('status.specified', <any>statusSpecified);
        }
        if (typeEquals !== undefined && typeEquals !== null) {
            queryParameters = queryParameters.set('type.equals', <any>typeEquals);
        }
        if (typeIn) {
            typeIn.forEach((element) => {
                queryParameters = queryParameters.append('type.in', <any>element);
            })
        }
        if (typeNotEquals !== undefined && typeNotEquals !== null) {
            queryParameters = queryParameters.set('type.notEquals', <any>typeNotEquals);
        }
        if (typeSpecified !== undefined && typeSpecified !== null) {
            queryParameters = queryParameters.set('type.specified', <any>typeSpecified);
        }
        if (userCodeContains !== undefined && userCodeContains !== null) {
            queryParameters = queryParameters.set('userCode.contains', <any>userCodeContains);
        }
        if (userCodeDoesNotContain !== undefined && userCodeDoesNotContain !== null) {
            queryParameters = queryParameters.set('userCode.doesNotContain', <any>userCodeDoesNotContain);
        }
        if (userCodeEquals !== undefined && userCodeEquals !== null) {
            queryParameters = queryParameters.set('userCode.equals', <any>userCodeEquals);
        }
        if (userCodeIn) {
            userCodeIn.forEach((element) => {
                queryParameters = queryParameters.append('userCode.in', <any>element);
            })
        }
        if (userCodeNotEquals !== undefined && userCodeNotEquals !== null) {
            queryParameters = queryParameters.set('userCode.notEquals', <any>userCodeNotEquals);
        }
        if (userCodeSpecified !== undefined && userCodeSpecified !== null) {
            queryParameters = queryParameters.set('userCode.specified', <any>userCodeSpecified);
        }
        if (userMemberOfIdEquals !== undefined && userMemberOfIdEquals !== null) {
            queryParameters = queryParameters.set('userMemberOfId.equals', <any>userMemberOfIdEquals);
        }
        if (userMemberOfIdGreaterThan !== undefined && userMemberOfIdGreaterThan !== null) {
            queryParameters = queryParameters.set('userMemberOfId.greaterThan', <any>userMemberOfIdGreaterThan);
        }
        if (userMemberOfIdGreaterThanOrEqual !== undefined && userMemberOfIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('userMemberOfId.greaterThanOrEqual', <any>userMemberOfIdGreaterThanOrEqual);
        }
        if (userMemberOfIdIn) {
            userMemberOfIdIn.forEach((element) => {
                queryParameters = queryParameters.append('userMemberOfId.in', <any>element);
            })
        }
        if (userMemberOfIdLessThan !== undefined && userMemberOfIdLessThan !== null) {
            queryParameters = queryParameters.set('userMemberOfId.lessThan', <any>userMemberOfIdLessThan);
        }
        if (userMemberOfIdLessThanOrEqual !== undefined && userMemberOfIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('userMemberOfId.lessThanOrEqual', <any>userMemberOfIdLessThanOrEqual);
        }
        if (userMemberOfIdNotEquals !== undefined && userMemberOfIdNotEquals !== null) {
            queryParameters = queryParameters.set('userMemberOfId.notEquals', <any>userMemberOfIdNotEquals);
        }
        if (userMemberOfIdSpecified !== undefined && userMemberOfIdSpecified !== null) {
            queryParameters = queryParameters.set('userMemberOfId.specified', <any>userMemberOfIdSpecified);
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('get',`${this.basePath}/api/rest/users/count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createUser
     * 
     * @param body userDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createUserUsingPOST(body: UserDTO, observe?: 'body', reportProgress?: boolean): Observable<UserDTO>;
    public createUserUsingPOST(body: UserDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDTO>>;
    public createUserUsingPOST(body: UserDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDTO>>;
    public createUserUsingPOST(body: UserDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createUserUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserDTO>('post',`${this.basePath}/api/rest/users`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deactivateUser
     * 
     * @param userCode userCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deactivateUserUsingDELETE(userCode: string, observe?: 'body', reportProgress?: boolean): Observable<UserDTO>;
    public deactivateUserUsingDELETE(userCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDTO>>;
    public deactivateUserUsingDELETE(userCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDTO>>;
    public deactivateUserUsingDELETE(userCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userCode === null || userCode === undefined) {
            throw new Error('Required parameter userCode was null or undefined when calling deactivateUserUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UserDTO>('delete',`${this.basePath}/api/rest/users/${encodeURIComponent(String(userCode))}/deactivate`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteUser
     * 
     * @param userCode userCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteUserUsingDELETE(userCode: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteUserUsingDELETE(userCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteUserUsingDELETE(userCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteUserUsingDELETE(userCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userCode === null || userCode === undefined) {
            throw new Error('Required parameter userCode was null or undefined when calling deleteUserUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/rest/users/${encodeURIComponent(String(userCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllUsers
     * 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param page Page number of the requested page
     * @param size Size of a page
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param statusEquals 
     * @param statusIn 
     * @param statusNotEquals 
     * @param statusSpecified 
     * @param typeEquals 
     * @param typeIn 
     * @param typeNotEquals 
     * @param typeSpecified 
     * @param userCodeContains 
     * @param userCodeDoesNotContain 
     * @param userCodeEquals 
     * @param userCodeIn 
     * @param userCodeNotEquals 
     * @param userCodeSpecified 
     * @param userMemberOfIdEquals 
     * @param userMemberOfIdGreaterThan 
     * @param userMemberOfIdGreaterThanOrEqual 
     * @param userMemberOfIdIn 
     * @param userMemberOfIdLessThan 
     * @param userMemberOfIdLessThanOrEqual 
     * @param userMemberOfIdNotEquals 
     * @param userMemberOfIdSpecified 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllUsersUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, statusEquals?: string, statusIn?: Array<string>, statusNotEquals?: string, statusSpecified?: boolean, typeEquals?: string, typeIn?: Array<string>, typeNotEquals?: string, typeSpecified?: boolean, userCodeContains?: string, userCodeDoesNotContain?: string, userCodeEquals?: string, userCodeIn?: Array<string>, userCodeNotEquals?: string, userCodeSpecified?: boolean, userMemberOfIdEquals?: number, userMemberOfIdGreaterThan?: number, userMemberOfIdGreaterThanOrEqual?: number, userMemberOfIdIn?: Array<number>, userMemberOfIdLessThan?: number, userMemberOfIdLessThanOrEqual?: number, userMemberOfIdNotEquals?: number, userMemberOfIdSpecified?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<UserDTO>>;
    public getAllUsersUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, statusEquals?: string, statusIn?: Array<string>, statusNotEquals?: string, statusSpecified?: boolean, typeEquals?: string, typeIn?: Array<string>, typeNotEquals?: string, typeSpecified?: boolean, userCodeContains?: string, userCodeDoesNotContain?: string, userCodeEquals?: string, userCodeIn?: Array<string>, userCodeNotEquals?: string, userCodeSpecified?: boolean, userMemberOfIdEquals?: number, userMemberOfIdGreaterThan?: number, userMemberOfIdGreaterThanOrEqual?: number, userMemberOfIdIn?: Array<number>, userMemberOfIdLessThan?: number, userMemberOfIdLessThanOrEqual?: number, userMemberOfIdNotEquals?: number, userMemberOfIdSpecified?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserDTO>>>;
    public getAllUsersUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, statusEquals?: string, statusIn?: Array<string>, statusNotEquals?: string, statusSpecified?: boolean, typeEquals?: string, typeIn?: Array<string>, typeNotEquals?: string, typeSpecified?: boolean, userCodeContains?: string, userCodeDoesNotContain?: string, userCodeEquals?: string, userCodeIn?: Array<string>, userCodeNotEquals?: string, userCodeSpecified?: boolean, userMemberOfIdEquals?: number, userMemberOfIdGreaterThan?: number, userMemberOfIdGreaterThanOrEqual?: number, userMemberOfIdIn?: Array<number>, userMemberOfIdLessThan?: number, userMemberOfIdLessThanOrEqual?: number, userMemberOfIdNotEquals?: number, userMemberOfIdSpecified?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserDTO>>>;
    public getAllUsersUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, statusEquals?: string, statusIn?: Array<string>, statusNotEquals?: string, statusSpecified?: boolean, typeEquals?: string, typeIn?: Array<string>, typeNotEquals?: string, typeSpecified?: boolean, userCodeContains?: string, userCodeDoesNotContain?: string, userCodeEquals?: string, userCodeIn?: Array<string>, userCodeNotEquals?: string, userCodeSpecified?: boolean, userMemberOfIdEquals?: number, userMemberOfIdGreaterThan?: number, userMemberOfIdGreaterThanOrEqual?: number, userMemberOfIdIn?: Array<number>, userMemberOfIdLessThan?: number, userMemberOfIdLessThanOrEqual?: number, userMemberOfIdNotEquals?: number, userMemberOfIdSpecified?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }
        if (statusEquals !== undefined && statusEquals !== null) {
            queryParameters = queryParameters.set('status.equals', <any>statusEquals);
        }
        if (statusIn) {
            statusIn.forEach((element) => {
                queryParameters = queryParameters.append('status.in', <any>element);
            })
        }
        if (statusNotEquals !== undefined && statusNotEquals !== null) {
            queryParameters = queryParameters.set('status.notEquals', <any>statusNotEquals);
        }
        if (statusSpecified !== undefined && statusSpecified !== null) {
            queryParameters = queryParameters.set('status.specified', <any>statusSpecified);
        }
        if (typeEquals !== undefined && typeEquals !== null) {
            queryParameters = queryParameters.set('type.equals', <any>typeEquals);
        }
        if (typeIn) {
            typeIn.forEach((element) => {
                queryParameters = queryParameters.append('type.in', <any>element);
            })
        }
        if (typeNotEquals !== undefined && typeNotEquals !== null) {
            queryParameters = queryParameters.set('type.notEquals', <any>typeNotEquals);
        }
        if (typeSpecified !== undefined && typeSpecified !== null) {
            queryParameters = queryParameters.set('type.specified', <any>typeSpecified);
        }
        if (userCodeContains !== undefined && userCodeContains !== null) {
            queryParameters = queryParameters.set('userCode.contains', <any>userCodeContains);
        }
        if (userCodeDoesNotContain !== undefined && userCodeDoesNotContain !== null) {
            queryParameters = queryParameters.set('userCode.doesNotContain', <any>userCodeDoesNotContain);
        }
        if (userCodeEquals !== undefined && userCodeEquals !== null) {
            queryParameters = queryParameters.set('userCode.equals', <any>userCodeEquals);
        }
        if (userCodeIn) {
            userCodeIn.forEach((element) => {
                queryParameters = queryParameters.append('userCode.in', <any>element);
            })
        }
        if (userCodeNotEquals !== undefined && userCodeNotEquals !== null) {
            queryParameters = queryParameters.set('userCode.notEquals', <any>userCodeNotEquals);
        }
        if (userCodeSpecified !== undefined && userCodeSpecified !== null) {
            queryParameters = queryParameters.set('userCode.specified', <any>userCodeSpecified);
        }
        if (userMemberOfIdEquals !== undefined && userMemberOfIdEquals !== null) {
            queryParameters = queryParameters.set('userMemberOfId.equals', <any>userMemberOfIdEquals);
        }
        if (userMemberOfIdGreaterThan !== undefined && userMemberOfIdGreaterThan !== null) {
            queryParameters = queryParameters.set('userMemberOfId.greaterThan', <any>userMemberOfIdGreaterThan);
        }
        if (userMemberOfIdGreaterThanOrEqual !== undefined && userMemberOfIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('userMemberOfId.greaterThanOrEqual', <any>userMemberOfIdGreaterThanOrEqual);
        }
        if (userMemberOfIdIn) {
            userMemberOfIdIn.forEach((element) => {
                queryParameters = queryParameters.append('userMemberOfId.in', <any>element);
            })
        }
        if (userMemberOfIdLessThan !== undefined && userMemberOfIdLessThan !== null) {
            queryParameters = queryParameters.set('userMemberOfId.lessThan', <any>userMemberOfIdLessThan);
        }
        if (userMemberOfIdLessThanOrEqual !== undefined && userMemberOfIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('userMemberOfId.lessThanOrEqual', <any>userMemberOfIdLessThanOrEqual);
        }
        if (userMemberOfIdNotEquals !== undefined && userMemberOfIdNotEquals !== null) {
            queryParameters = queryParameters.set('userMemberOfId.notEquals', <any>userMemberOfIdNotEquals);
        }
        if (userMemberOfIdSpecified !== undefined && userMemberOfIdSpecified !== null) {
            queryParameters = queryParameters.set('userMemberOfId.specified', <any>userMemberOfIdSpecified);
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserDTO>>('get',`${this.basePath}/api/rest/users`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getUserPermission
     * 
     * @param userCode userCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserPermissionUsingGET(userCode: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public getUserPermissionUsingGET(userCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public getUserPermissionUsingGET(userCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public getUserPermissionUsingGET(userCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userCode === null || userCode === undefined) {
            throw new Error('Required parameter userCode was null or undefined when calling getUserPermissionUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<string>>('get',`${this.basePath}/api/rest/users/${encodeURIComponent(String(userCode))}/code-permissions`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getUser
     * 
     * @param userCode userCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserUsingGET(userCode: string, observe?: 'body', reportProgress?: boolean): Observable<UserDTO>;
    public getUserUsingGET(userCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDTO>>;
    public getUserUsingGET(userCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDTO>>;
    public getUserUsingGET(userCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userCode === null || userCode === undefined) {
            throw new Error('Required parameter userCode was null or undefined when calling getUserUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UserDTO>('get',`${this.basePath}/api/rest/users/${encodeURIComponent(String(userCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * reactivateUser
     * 
     * @param userCode userCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reactivateUserUsingPUT(userCode: string, observe?: 'body', reportProgress?: boolean): Observable<UserDTO>;
    public reactivateUserUsingPUT(userCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDTO>>;
    public reactivateUserUsingPUT(userCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDTO>>;
    public reactivateUserUsingPUT(userCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userCode === null || userCode === undefined) {
            throw new Error('Required parameter userCode was null or undefined when calling reactivateUserUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UserDTO>('put',`${this.basePath}/api/rest/users/${encodeURIComponent(String(userCode))}/reactivate`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateUser
     * 
     * @param body userDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateUserUsingPUT(body: UserDTO, observe?: 'body', reportProgress?: boolean): Observable<UserDTO>;
    public updateUserUsingPUT(body: UserDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDTO>>;
    public updateUserUsingPUT(body: UserDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDTO>>;
    public updateUserUsingPUT(body: UserDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateUserUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserDTO>('put',`${this.basePath}/api/rest/users`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
